<template>
  <div class="userCenter">
    <div class="back" @click="handleBack">
      <a-button type="primary"
      ><i class="iconfont icon-fanhuiicon mr5"></i> 返回</a-button
      >
    </div>

    <div class="userCenter-content">
      <!-- 左侧个人信息区域 -->
      <div class="userInfo-section">
        <div class="avatar-container">
          <div class="avatar">
            <img v-if="state.user.avatar" :src="state.user.avatar" alt="用户头像">
            <div v-else class="default-avatar">{{ getInitials(state.user.nickName) }}</div>
            <div class="avatar-edit">
              <a-icon type="plus" class="upload-icon" />
            </div>
          </div>
        </div>

        <div class="user-details">
<!--          <div class="detail-item">-->
<!--            <span class="detail-label">用户账号</span>-->
<!--            <span class="detail-value">{{ state.user.userName}}</span>-->
<!--          </div>-->
          <div class="detail-item">
            <span class="detail-label">手机号码</span>
            <span class="detail-value">{{ state.user.phonenumber }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">用户昵称</span>
            <span class="detail-value">{{ state.user.nickName}}</span>
          </div>

          <div class="detail-item">
            <span class="detail-label">用户邮箱</span>
            <span class="detail-value">{{ state.user.email}}</span>
          </div>
          <div class="detail-item" v-if="store.roles.includes('enterprise')">
            <span class="detail-label">所属企业</span>
            <span class="detail-value" v-if="state.user.dept">{{ state.user.dept.deptName }}</span>
          </div>
          <div class="detail-item" v-if="!store.roles.includes('enterprise')">
            <span class="detail-label">所属角色</span>
            <span class="detail-value" v-if="state.user.dept">{{ state.roleGroup }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">创建日期</span>
            <span class="detail-value">{{ state.user.createTime }}</span>
          </div>
        </div>
      </div>

      <!-- 右侧设置区域 -->
      <div class="settings-section">
        <a-tabs v-model:activeKey="activeTab" @change="handleTabChange">
          <a-tab-pane key="1" tab="基本设置">
            <BasicSettings :user="state.user" @update:userInfo="updateUserInfo" />
          </a-tab-pane>
          <a-tab-pane key="2" tab="企业信息" v-if="store.roles.includes('enterprise')">
            <Enterprise :user="state.user" @update:userInfo="updateUserInfo" />
          </a-tab-pane>
          <a-tab-pane key="3" tab="密码设置">
            <PasswordSettings />
          </a-tab-pane>
        </a-tabs>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted } from "vue";
import { message } from "ant-design-vue";
import { useRouter } from "vue-router";
import useUserStore from '@/store/modules/user';
import { getUserProfile  } from '@/api/system/user';
import BasicSettings from './components/userInfo.vue';
import PasswordSettings from './components/resetPwd.vue';
import Enterprise from './components/enterprise.vue'

const router = useRouter();
const store = useUserStore();

// 标签页
const activeTab = ref('1');

// 用户信息
const state = reactive({
  user: {},
  roleGroup: {},
});

// 获取用户信息
const getUserInfo = () => {
  getUserProfile().then(response => {
    state.user = response.data;
    state.roleGroup = response.roleGroup;
  });
};

// 更新用户信息
const updateUserInfo = (newUserInfo) => {
  state.user = { ...newUserInfo };
};

function getInitials(name) {
  if (!name) return 'A';
  // 如果名字大于三个字，只取最后两个字
  if (name.length >= 3) {
    return name.substring(name.length - 2);
  }
  // 否则返回完整名字
  return name;
}

// 处理标签页切换
const handleTabChange = (key) => {
  activeTab.value = key;
};

// 返回上一页
const handleBack = () => {
  router.back();
};

// 页面加载时获取用户信息
onMounted(() => {
  getUserInfo();
});
</script>

<style lang="less" scoped>
.userCenter {
  padding: 20px;
  height: calc(100vh - 70px - 57px);
  background-color: #ffffff;
  overflow-y: auto;

  .back {
    position: fixed;
    top: 93px;
    right: 50px;
  }

  .userCenter-content {
    display: flex;
    gap: 30px;
    margin-top: 20px;
  }

  // 左侧个人信息区域
  .userInfo-section {
    flex: 0 0 350px;

    border-radius: 8px;
    padding: 30px;
    height: fit-content;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

    .avatar-container {
      text-align: center;
      margin-bottom: 30px;

      .avatar {
        position: relative;
        width: 120px;
        height: 120px;
        border-radius: 50%;
        margin: 0 auto 15px;
        overflow: hidden;
        background-color: #e8e8e8;
        cursor: pointer;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .default-avatar {
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 48px;
          font-weight: bold;
          color: #fff;
          background-color: #1890ff
        }

        .avatar-edit {
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          height: 40px;
          background: rgba(0, 0, 0, 0.4);
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          opacity: 0;
          transition: opacity 0.3s;

          &:hover {
            opacity: 1;
          }

          .upload-icon {
            color: #fff;
            font-size: 16px;
          }
        }
      }

      .user-name {
        font-size: 20px;
        font-weight: 600;
        color: #1d2129;
        margin-bottom: 5px;
      }

      .user-level {
        font-size: 14px;
        color: #636d7b;
      }
    }

    .user-details {
      .detail-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 12px 0;
        border-bottom: 1px solid #e8e8e8;

        &:last-child {
          border-bottom: none;
        }

        .detail-label {
          font-size: 14px;
          color: #636d7b;
        }

        .detail-value {
          font-size: 14px;
          color: #1d2129;
          text-align: right;
          flex: 1;
          margin-left: 10px;
        }
      }
    }
  }

  // 右侧设置区域
  .settings-section {
    flex: 1;
    background-color: #fff;
    border-radius: 8px;
    padding: 24px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

    .ant-tabs {
      .ant-tabs-nav {
        margin-bottom: 30px;
      }

      .ant-tabs-tab {
        font-size: 16px;
      }
    }
  }
}
</style>